import React, { Component } from 'react';
import { withRouter } from '../../withRouter';
import { getCookie, setCookie } from 'helpers/cookies'
import { connect, } from 'react-redux';
import { addToCart } from 'actions/cart';

import styles from 'components/Modals/UpsellModal/UpsellModalStyles.module.scss';
import PricingFunctions from 'common/PricingFunctions';

class UpsellModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            enabled: true,
            show: true,
        };
    }

    show() {
        this.setState({ enable: true, show: true });
    }

    componentDidMount() {
    }

    addToCart = () => {
        if (!this.state.show) return;
        this.props.addToCart(this.props.upsellItem);
        this.setState({ show: false });
        setTimeout(() => {
            this.setState({ enabled: false });
            this.props.callback();
        }, 500);
    }

    goToGame = (e) => {
        e.preventDefault();
        this.props.navigate(this.props.upsellItem.storeSlug)
    }

    getPrice(game) {
        return PricingFunctions.getGamePricing(this.props.pricing.countryCode, game).display;
    }

    close = (e) => {
        e.preventDefault();
        this.setState({show: false});
        setTimeout(() => {
            this.setState({ enabled: false });
            this.props.callback();
        }, 500);
    }

    render() {
        console.log("this.state.show upsell modal : ", this.state.show)
        return <React.Fragment>
            <div className={`${styles.screenOverlay} ${this.state.show && styles.show} ${this.props.styles}`} >
                <div className={styles.screenOverlayBG}></div>
                <div className={styles.modalContainer} >
                    <div className={styles.modal} >
                        <h1 className={styles.title}>WE THINK YOU'LL LOVE</h1>
                        <div className={`${styles.background} ${styles.columbs}`} >
                            <div className={`${styles.columb} ${styles.center}`}>
                                <div className={styles.priceBanner} style={{ background: this.props.upsellItem.meta.cardPriceColour }}><span>{this.getPrice(this.props.upsellItem)}</span></div>
                                <img className={styles.gameCard} src={this.props.upsellItem.meta.tinyCard} onClick={this.goToGame} alt="required"></img>
                            </div>
                            <div className={`${styles.columb}`}>
                                <div className={`${styles.details}`} >
                                    <h3>{this.props.upsellItem.name}</h3>
                                    <p>{this.props.upsellItem.description}</p>
                                </div>
                            </div>
                        </div>
                        <div className={styles.buttons}>
                            <button onClick={this.close} className={`${styles.button} ${styles.alternate}`} style={{ margin: "0 10px" }}>NO THANKS</button>
                            <button onClick={this.props.purchaseCallback || this.addToCart} className={`${styles.button} `} style={{ margin: "0 10px" }}>{this.props.overrideText || "ADD TO CART"}</button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pricing: state.pricing,
        cart: state.cart
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (game) => {
            dispatch(addToCart(game))
        }
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UpsellModal));